import {createContext} from 'react';

const EmmaiContext = createContext(null);

export default EmmaiContext;
